export const TOUR_STEP_IDS = {
  SETTINGS_BUTTON: "settings-button",
  Settings: {
    TwoFactor: {
      CARD: "settings-two-factor-card",
      SWITCH: "two-factor-switch-step",
    },
  },
};
